import * as cn from "classnames";
import * as React from "react";
import Text from "../../../../shared/components/text";
import * as styles from "./styles.css";
var BookingRating = function (_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement(Text.Italic, { className: cn(styles.bookingRating, className) }, children));
};
export default BookingRating;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/booking/bookingRating.tsx
// module id = Wni0
// module chunks = 2